import React, { useState } from 'react';
import { Package, ZoomIn } from 'lucide-react';

interface SupplyThumbnailProps {
  imageUrl?: string;
  alt: string;
  size?: 'sm' | 'md' | 'lg';
  showZoom?: boolean;
  onClick?: () => void;
}

const SupplyThumbnail: React.FC<SupplyThumbnailProps> = ({
  imageUrl,
  alt,
  size = 'md',
  showZoom = false,
  onClick,
}) => {
  const [imageError, setImageError] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const sizeClasses = {
    sm: 'w-10 h-10',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
  };

  const iconSizes = {
    sm: 'h-5 w-5',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
  };

  const hasValidImage = imageUrl && !imageError && imageUrl.trim() !== '';

  return (
    <div
      className={`relative ${sizeClasses[size]} flex-shrink-0 rounded-md overflow-hidden border-2 border-gray-200 bg-gray-50 ${
        onClick || showZoom ? 'cursor-pointer hover:border-blue-500' : ''
      } transition-all duration-200`}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={(e) => {
        if (onClick && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          onClick();
        }
      }}
    >
      {hasValidImage ? (
        <>
          <img
            src={imageUrl}
            alt={alt}
            className="w-full h-full object-cover"
            onError={() => setImageError(true)}
            loading="lazy"
          />
          {showZoom && isHovered && (
            <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center">
              <ZoomIn className="h-5 w-5 text-white" />
            </div>
          )}
        </>
      ) : (
        <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-gray-100 to-gray-200">
          <Package className={`${iconSizes[size]} text-gray-600`} />
        </div>
      )}
    </div>
  );
};

export default SupplyThumbnail;
